module.exports = "<iframe id=\"certificate-holder\" class=\"preview-body\" frameborder=\"0\"></iframe>\n<div class=\"row\">\n    <div class=\"col-md-12\" style=\"text-align: center\">\n        <hr>\n        <button type=\"type\" (click)=\"downloadClick()\" class=\"btn btn-primary\">\n            <i class=\"fa fa-download\"></i> Download\n        </button>\n        <p style=\"margin: 4px 0 0 0;\"><small>Download a sample</small></p>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/preview-certificate/preview-certificate.component.html
// module id = ./src/app/shared/components/preview-certificate/preview-certificate.component.html
// module chunks = main